import { render, staticRenderFns } from "./ImageSliderElement.vue?vue&type=template&id=6cdff534&scoped=true&"
import script from "./ImageSliderElement.vue?vue&type=script&lang=js&"
export * from "./ImageSliderElement.vue?vue&type=script&lang=js&"
import style0 from "./ImageSliderElement.vue?vue&type=style&index=0&id=6cdff534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdff534",
  null
  
)

export default component.exports